import React from "react";
import "./White-Button.css";

interface WhiteButtonProps {
  label: string;
  action?: any;
  uppercase?: boolean;
  disabled?: boolean;
  style?: any;
}

const WhiteButton = ({
  label,
  action,
  uppercase,
  disabled,
  style,
}: WhiteButtonProps) => {
  if (disabled) {
    return (
      <button
        className="disable-white-button"
        style={style}
        onClick={() => {
          action();
        }}
      >
        {label}
      </button>
    );
  } else if (action) {
    return (
      <button
        className="white-button"
        style={style}
        onClick={() => {
          action();
        }}
      >
        {label}
      </button>
    );
  } else {
    return (
      <button className="white-button" style={style}>
        {label}
      </button>
    );
  }
};

export default WhiteButton;
